import {
  REFERRALSOURCE_TABLE,
  GET_REFERRALSOURCE_LIST_PENDING,
  GET_REFERRALSOURCE_LIST_FULFILLED,
  GET_REFERRALSOURCE_LIST_REJECTED,
  GET_REFERRALSOURCE_PENDING,
  GET_REFERRALSOURCE_FULFILLED,
  GET_REFERRALSOURCE_REJECTED,
  DELETE_REFERRALSOURCE_FULFILLED,
  DELETE_REFERRALSOURCE_PENDING,
  ADD_REFERRALSOURCE_FULFILLED,
  UPDATE_REFERRALSOURCE_FULFILLED
} from '../../actions/action-constants'
const initialState = {
  title: 'Referral Sources',
  tablename: REFERRALSOURCE_TABLE,
  referralsources: [],
  loadingList: false,
  errors: []
}
const reducerReferralSources = (state = initialState, action) => {
  var dataUndefinedTestReturn
  switch (action.type) {
    case GET_REFERRALSOURCE_PENDING:
    case GET_REFERRALSOURCE_LIST_PENDING:
    case DELETE_REFERRALSOURCE_PENDING:
      state = {
        ...state,
        loadingList: true
      }
      break
    case GET_REFERRALSOURCE_LIST_FULFILLED:
      dataUndefinedTestReturn =
        typeof action.payload.data !== 'undefined' &&
        action.payload.data !== null
          ? action.payload.data.dropdowns
          : []
      state = {
        ...state,
        loadingList: false,
        addSuccess: false,
        updateSuccess: false,
        deleteSuccess: false,
        referralsources: dataUndefinedTestReturn
      }
      break
    case GET_REFERRALSOURCE_FULFILLED:
      dataUndefinedTestReturn =
        typeof action.payload.data !== 'undefined' &&
        action.payload.data !== null
          ? action.payload.data.dropdowns
          : []
      state = {
        ...state,
        loadingList: false,
        referralsources: dataUndefinedTestReturn
      }
      break
    case DELETE_REFERRALSOURCE_FULFILLED:
      state = {
        ...state,
        loadingList: false,
        deleteSuccess: true
      }
      break
    case ADD_REFERRALSOURCE_FULFILLED:
      state = {
        ...state,
        loadingList: false,
        addSuccess: true
      }
      break
    case UPDATE_REFERRALSOURCE_FULFILLED:
      state = {
        ...state,
        loadingList: false,
        updateSuccess: true
      }
      break
    case GET_REFERRALSOURCE_LIST_REJECTED:
    case GET_REFERRALSOURCE_REJECTED:
      state = {
        ...state,
        errors: [action.payload.response]
      }
      break
    default:
      return state
  }
  return state
}
export default reducerReferralSources
